/* Drippy · "Add the matching piece" on a single chain / bracelet page (2026-10-15).
 *
 * Ticked: Add to cart posts this piece AND the partner as two lines sharing a
 * _bundle_id, so the checkout's set discount applies to that pair (and only
 * that pair). Unticked: nothing changes, the theme's own form posts as always.
 * The offer's price follows the size picked on the page (pieces can differ in
 * price by size): partner price minus the set saving (same maths as the
 * discount function and drippy-set-math.liquid).
 */
(function () {
  'use strict';
  if (window.__drippySetOffer) return;
  window.__drippySetOffer = true;

  function offer() {
    var all = document.querySelectorAll('[data-set-offer]');
    for (var i = 0; i < all.length; i++) if (!all[i].closest('.product__popup')) return all[i];
    return null;
  }
  function on() { var o = offer(); var c = o && o.querySelector('[data-offer-check]'); return !!(c && c.checked); }
  function mainForm() {
    var fs = document.querySelectorAll('.product__info-container form[data-type="add-to-cart-form"]');
    for (var i = 0; i < fs.length; i++) if (!fs[i].closest('.product__popup')) return fs[i];
    return fs[0] || null;
  }
  function currentVariant() {
    var f = mainForm(); var i = f && f.querySelector('input[name="id"]');
    return i ? parseInt(i.value, 10) : 0;
  }
  function currentPrice() {
    var id = currentVariant();
    var j = document.querySelector('.product__info-container [data-all-variants-no-high]') || document.querySelector('[data-all-variants-no-high]');
    try { var vs = JSON.parse(j.textContent); for (var i = 0; i < vs.length; i++) if (vs[i].id === id) return vs[i].price; } catch (e) {}
    return null;
  }

  var FMT = null;
  function money(cents) {
    if (!FMT) {
      var s = document.querySelector('[data-offer-price][data-money-sample]');
      var m = s && String(s.getAttribute('data-money-sample')).match(/1(\D?)234(\D)56/);
      var t = s && s.getAttribute('data-money-sample');
      FMT = m ? { pre: t.slice(0, t.indexOf(m[0])), post: t.slice(t.indexOf(m[0]) + m[0].length), th: m[1], dec: m[2] } : { pre: '€', post: '', th: '.', dec: ',' };
    }
    cents = Math.round(cents);
    var whole = Math.floor(cents / 100), frac = cents % 100;
    return FMT.pre + String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, FMT.th) + (frac ? FMT.dec + (frac < 10 ? '0' : '') + frac : '') + FMT.post;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function paint() {
    var o = offer(); if (!o) return;
    var sizes = o.querySelector('[data-offer-sizes]');
    sizes.hidden = !on();
    var r = o.querySelector('[data-offer-variant]:checked');
    var me = currentPrice();
    var el = o.querySelector('[data-offer-price]');
    if (!r) r = o.querySelector('[data-offer-variant]:not(:disabled)');
    if (me == null) { var fi = o.querySelector('[data-offer-variant]'); }
    if (!r || me == null || !el) return;
    var pp = parseInt(r.dataset.offerVprice, 10);
    /* the set code takes a fixed EUR amount off; outside the euro Shopify converts it at
       Shopify.currency.rate (rounded to cents), so the offer shows exactly that */
    var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
    var sav = Math.round(parseInt(o.dataset.saving || '0', 10) * rate);
    var setp = pp - sav; if (rate !== 1) setp = Math.ceil(setp / 100) * 100; /* whole price, rounded up (Johannes 2026-10-15) */
    el.innerHTML = el.dataset.tpl.replace('%P', '<b>' + esc(money(setp)) + '</b>').replace('%C', '<s>' + esc(money(pp)) + '</s>');
    el.classList.remove('d-fx');
  }

  function drawer() { return document.querySelector('cart-drawer'); }
  function busy(form, b) {
    var btn = form && form.querySelector('[name="add"]');
    if (!btn) return;
    btn.classList.toggle('loading', b);
    btn.setAttribute('aria-disabled', b ? 'true' : 'false');
    var sp = btn.querySelector('.loading-overlay__spinner'); if (sp) sp.classList.toggle('hidden', !b);
  }

  /* Capture phase on document runs before the theme's product-form handler on
     the form itself; stopping here keeps the single-line add from running. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('data-type') !== 'add-to-cart-form' || !on()) return;
    var o = offer(); var r = o && o.querySelector('[data-offer-variant]:checked');
    var mine = parseInt((form.querySelector('input[name="id"]') || {}).value || '0', 10);
    if (!mine) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (!r) {
      /* Ticked but no partner size yet: ask for it, never add the piece alone. */
      var fs = o.querySelector('[data-offer-step]');
      if (fs) {
        fs.classList.remove('d-offer--ask'); void fs.offsetWidth; fs.classList.add('d-offer--ask');
        var lg = fs.querySelector('legend'); if (lg && !lg.dataset.base) lg.dataset.base = lg.textContent;
        o.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = fs.querySelector('input:not(:disabled) + label'); if (first) first.focus && first.focus();
      }
      return;
    }
    var q = parseInt((form.querySelector('input[name="quantity"]') || {}).value || '1', 10) || 1;
    var id = 'set-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var props = { _bundle_id: id, _bundle_name: o.dataset.setName || '', _bundle_handle: o.dataset.setHandle || '' };
    var body = { items: [{ id: mine, quantity: q, properties: props }, { id: parseInt(r.dataset.offerVariant, 10), quantity: 1, properties: props }] };
    var d = drawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      body.sections = d.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    busy(form, true);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify(body) })
      .then(function (res) { return res.json(); })
      .then(function (res) {
        if (res.status || !o.dataset.setCode) return res;
        /* apply the set's code (the set price), keeping codes already in the cart */
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); }).then(function (c) {
          var list = (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
          if (list.indexOf(o.dataset.setCode) === -1) list.push(o.dataset.setCode);
          var b = { discount: list.join(',') };
          if (body.sections) { b.sections = body.sections; b.sections_url = body.sections_url; }
          return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) }).then(function (x) { return x.json(); });
        }).catch(function () { return res; });
      })
      .then(function (res) {
        busy(form, false);
        if (res.status) {
          var w = form.closest('product-form') && form.closest('product-form').querySelector('.product-form__error-message-wrapper');
          if (w) { w.hidden = false; var m = w.querySelector('.product-form__error-message'); if (m) m.textContent = res.description || res.message || ''; }
          return;
        }
        var dd = drawer();
        if (dd && dd.renderContents && res.sections) { dd.renderContents(res); if (dd.open) dd.open(); }
        else window.location.href = root + 'cart';
      })
      .catch(function () { busy(form, false); window.location.href = root + 'cart'; });
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && (t.matches('[data-offer-check]') || t.matches('[data-offer-variant]') || t.closest('variant-radios, variant-selects, .product-form__controls'))) setTimeout(paint, 0);
  });
  /* The theme swaps the hidden variant id after its own fetch; repaint then. */
  function watchId() {
    var f = mainForm(); var i = f && f.querySelector('input[name="id"]');
    if (!i || !window.MutationObserver) return;
    new MutationObserver(function () { setTimeout(paint, 0); }).observe(i, { attributes: true, attributeFilter: ['value'] });
    var last = i.value; setInterval(function () { if (i.value !== last) { last = i.value; paint(); } }, 400);
  }
  function boot() { paint(); watchId(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
